// AnomalyBadge — sticky header'da görünen ⚠ rozet (CR2-08).
// Yokken-yok kuralı: count === 0 → null döner (DOM'da yer kapamaz).
// Tıklama → /anomaliler. App-level state ile besleneceği için kendisi
// hiçbir veri çekmez; sadece count + onClick alır.
//
// Sketch (04-prototype/sketch.html) header rozetiyle birebir hizalı:
//   bg: warn-500/15  ·  text: warn-400  ·  border: warn-500/30
//   "badge-in" animasyonu styles.css'ten gelir.

interface Props {
  count: number;
  onClick: () => void;
}

export default function AnomalyBadge({ count, onClick }: Props) {
  if (count <= 0) return null;
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`${count} açık anomali`}
      className="inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-1 rounded-full bg-warn-500/15 text-warn-400 border border-warn-500/30 hover:bg-warn-500/25 transition badge-in"
    >
      <svg
        width="11"
        height="11"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M12 9v4M12 17h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      </svg>
      <span>{count}</span>
    </button>
  );
}
